export default [
  {
    header: "Apps",
  },
  {
    title: "HEX",
    token: "hex.png",
    to: "/apps/hex",
  },
  {
    title: "Hedron",
    token: "hdrn.png",
    to: "/apps/hedron",
  },
  {
    title: "Icosa",
    token: "icsa.png",
    to: "/apps/icosa",
  },
  {
    title: "HSI Auctions",
    token: "hsi.png",
    to: "/apps/auction",
  },
];
